import React, { useState, useEffect } from "react";
import "../styles/HeroSection.css";

// Import Logos
import logo from "../images/download.png"; // Logo for first and second slides
import cheImg from "../images/che.png"; // Logo for third slide

// Import Slide Images
import firstSlide from "../images/second_slide.webp";
import secondSlide from "../images/first_slide.webp";
import thirdSlide from "../images/third_slide.webp";

const slides = [
  {
    image: firstSlide,
    title: "Balmerol Automotive",
    description: "Leading the way in advanced lubrication for automobiles.",
    content: `
      Balmerol Automotive offers a premium range of high-performance lubricants 
      designed to enhance engine efficiency, improve fuel economy, and extend 
      vehicle lifespan. Our innovative formulations ensure superior protection 
      against wear, friction, and extreme temperatures, making every drive 
      smoother and more efficient.
    `,
    points: [
      "High-Performance Engine Oils",
      "Advanced Transmission Fluids",
      "Superior Wear Protection",
      "Improved Fuel Efficiency",
      "Extended Engine Life",
    ],
    logo: logo, // First slide uses download.png
  },
  {
    image: secondSlide,
    title: "Balmerol Industrial",
    description: "Providing reliable lubrication solutions for industries worldwide.",
    content: `
      Balmerol Industrial lubricants are trusted by businesses globally to 
      optimize machinery performance and minimize downtime. Our range of 
      industrial-grade oils and greases ensure smooth operations in extreme 
      conditions, increasing productivity and reducing maintenance costs.
    `,
    points: [
      "High-Quality Hydraulic Oils",
      "Gear Oils for Heavy Machinery",
      "Heat-Resistant Greases",
      "Corrosion Protection",
      "Longer Equipment Lifespan",
    ],
    logo: logo, // Second slide uses download.png
  },
  {
    image: thirdSlide,
    title: "Chemoleum Automotive",
    description: "Pioneering advanced motor oils and fuel additives for modern engines.",
    content: `
      Chemoleum Automotive brings cutting-edge technology to lubrication, 
      delivering superior motor oils that maximize engine performance and 
      efficiency. Our formulations meet the highest industry standards, ensuring 
      optimal power output and engine protection across all driving conditions.
    `,
    points: [
      "Premium Motor Oils",
      "Diesel and Gasoline Additives",
      "Automatic Transmission Fluids",
      "Enhanced Engine Cleanliness",
      "Maximum Power Output",
    ],
    logo: cheImg, // Third slide uses che.png
  },
];

const HeroSection = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (!isPaused) {
      const slideInterval = setInterval(() => {
        setActiveSlide((prevSlide) => (prevSlide + 1) % slides.length);
      }, 7000);
      return () => clearInterval(slideInterval);
    }
  }, [isPaused]);

  return (
    <div className="hero-section">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`slide ${activeSlide === index ? "active" : ""}`}
          style={{ backgroundImage: `url(${slide.image})` }}
          onClick={() => setIsPaused(!isPaused)}
        >
          {/* Logo Positioned in Top-Left Corner */}
          <img src={slide.logo} alt="Brand Logo" className="top-left-logo" />

          {/* Slide Content Overlay */}
          <div className="slide-content">
            <h2>{slide.title}</h2>
            <p className="description">{slide.description}</p>
            <p className="content">{slide.content}</p>
            <ul>
              {slide.points.map((point, i) => (
                <li key={i}>{point}</li>
              ))}
            </ul>
          </div>
        </div>
      ))}

      {/* Navigation Dots */}
      <div className="dots-container">
        {slides.map((_, index) => (
          <span
            key={index}
            className={`dot ${activeSlide === index ? "active" : ""}`}
            onClick={() => setActiveSlide(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroSection;
